import { Box, Hidden } from "@material-ui/core";
import React, { useEffect, useState } from "react";

import { useRouteMatch } from "react-router-dom";
import Authorities from "../../../../auth/authorities";
import DefaultAlert from "../../../../components/alerts/DefaultAlert";
import withAuthority from "../../../../components/Auth/withAuthority";
import { ERROR_MESSAGE_UNEXPECTED_ERROR } from "../../../../utils/consts";
import ThemeService from "../../services/ThemeService";
import BannersMap from "./BannersMap";
import PageHeaderMobile from "../../../../components/common/PageHeader/PageHeaderMobile";

/**
 * Banners Component:
 *
 * This component represents the main view for managing banners. It retrieves and displays
 * banner-related information based on the selected location. It also handles errors and
 * loading states while fetching data.
 */
const Banners: React.FunctionComponent<{}> = () => {
  const [themeNodeList, setThemeNodeList] = useState<any>([]);
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  // const [locationData, setLocationData] = useState({ businessDisplayName: "" });

  const match: any = useRouteMatch();

  /* Get all theme information using API call and response data set to themeNodeList state. */
  const getThemeInfo = async () => {
    try {
      const res = await ThemeService.getThemeConfig(match.params.locationId);
      setIsLoading(false);
      const order = ["", "STORE_POPUP", "PAYMENT_INLINE"];
      const output = [...res.data.data.banners].sort((a, b) => {
        const indexA = order.indexOf(a.bannerType);
        const indexB = order.indexOf(b.bannerType);
        return indexA - indexB;
      });
      res.data.data.banners = output;
      setThemeNodeList(res.data.data);
      setIsLoading(false);
    } catch (err) {
      setError(ERROR_MESSAGE_UNEXPECTED_ERROR);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    document.title = "Eat Presto - Banner";
    setIsLoading(true);
    getThemeInfo();
  }, []);

  return (
    <div>
      <Hidden lgUp>
        <PageHeaderMobile />
      </Hidden>
      <Box style={{ marginTop: "18px" }}>
        <BannersMap
          nodes={themeNodeList}
          isLoading={isLoading}
          getThemeInfo={getThemeInfo}
        />
      </Box>
      <DefaultAlert
        open={!!error}
        handleClose={() => setError("")}
        message={error}
        severity="error"
      />
    </div>
  );
};

export default withAuthority(Banners, Authorities.BANNERS_READ);
